import React from "react";

import { Box } from "@mui/material";
import MainHeader from "../../shared/MainHeader";

import AssignPvtCaseTable from "../../components/AssignPvtCaseTable";

const PvtCase = () => {
  return (
    <Box>
      <MainHeader headingText={"Unassigned Private Case"} />

      <AssignPvtCaseTable />
    </Box>
  );
};

export default PvtCase;
